import { useMemo } from 'react';
import { useExplorerRiskCurrentQuery } from '@apolloGenerated';
import { getNetworkEnum } from '@helpers/address';

export type GetRiskDataType = {
  risk?: number;
  category?: string;
  isLoading?: boolean;
};

export function useClusterRisk(category: number): GetRiskDataType {
  const { data: categoryList, loading } = useExplorerRiskCurrentQuery({
    variables: {
      network: getNetworkEnum('btc'),
    },
  });

  const risk = useMemo(() => {
    if (!categoryList?.explorerRiskCurrent?.params) return null;
    return Object.values(categoryList.explorerRiskCurrent?.params).find(
      (item) => item.number === category,
    );
  }, [category, categoryList]);

  return {
    risk: risk?.risk,
    category: risk?.name,
    isLoading: loading,
  };
}
